import React from 'react';

import constants from 'constants/constants';
import moment from 'moment-timezone';
import { useHistory } from 'react-router-dom';

import { DEFAULT_ERROR, useCustomSnackBar } from 'hooks/useCustomSnackBar';

import { useMobileStore } from 'store/mobile.store';

import { useMutationSetNotificationsReadStatus } from 'api/mutations/setNotificationsReadStatus.mutation';

import { ProfileImage } from 'components/common/ProfileImage/profileImage';

import classes from 'components/App/AuthenticateLayout/Header/Notification/NotificationItem/NotificationItem.module.scss';
import { IGetNotificationsResponse } from 'components/App/AuthenticateLayout/Header/Notification/Notifications.types';
import { CustomizedTooltip } from 'components/common';

interface INotificationItemProps {
    item: IGetNotificationsResponse;
}

const NotificationItem = ({ item }: INotificationItemProps) => {
    const mutation = useMutationSetNotificationsReadStatus();
    const history = useHistory();
    const { handleSnackBar } = useCustomSnackBar();
    const isMobile = useMobileStore((state) => state.isMobile);

    /**
     * toggle notification read status
     */
    const toggleRead = () => {
        mutation.mutate(
            {
                consumer_email: item.consumerName,
                id_list: [item.id],
                read: !item.isRead,
            },
            {
                onError: (error) => {
                    DEFAULT_ERROR({ error, handleError: handleSnackBar });
                },
            },
        );
    };

    /**
     * set notification read status to "true" and opens the link of the notification
     */
    const clickOnItem = () => {
        mutation.mutate(
            {
                consumer_email: item.consumerName,
                id_list: [item.id],
                read: true,
            },
            {
                onSuccess: () => {
                    if (!isMobile) {
                        history.push(`/${item.permLink}`);
                    }
                },
                onError: (error) => {
                    DEFAULT_ERROR({ error, handleError: handleSnackBar });
                },
            },
        );
    };
    return (
        <div data-testid={'notification-item'} className={classes.notificationItem}>
            <div className={classes.iconContainer}>
                <CustomizedTooltip
                    triggerElement={
                        <ProfileImage
                            fullName={`${item.assignee.firstName} ${item.assignee.lastName}`}
                            email={item.assignee.userName}
                            imageName={item.assignee.imageName}
                            isUnassigned={item.assignee.id === -1}
                        />
                    }
                    tooltipContent={`${item.assignee.firstName} ${item.assignee.lastName}`}
                />
            </div>
            <div className={classes.body}>
                <div onClick={clickOnItem} className={classes.title}>
                    {item.description}
                </div>
                <div className={classes.date}>
                    {moment(item.createdAt).format(constants.formats.date.defaultWithTime)}
                </div>
            </div>
            <div className={classes.isReadContainer}>
                <div className={`${classes.indicator} ${!item.isRead && classes.checked}`} onClick={toggleRead} />
            </div>
        </div>
    );
};

export default NotificationItem;
